import { Form as RubicsForm } from "@ludens-reklame/rubics-v3-sdk/form/types";
import { exit } from "../../icons/svg.js";
import { Form } from "../form/form.js";

export interface Props {
  despawnModal: () => void;
  form: RubicsForm;
}

export const FormModal: React.FC<Props> = ({ despawnModal, form }) => {
  return (
    <div className="modal-container form-modal">
      <div className="modal-header">
        <button onClick={despawnModal} title="Lukk">
          {exit}
        </button>
      </div>
      <Form form={form} />
    </div>
  );
};
